import { Grid, TextField, FormControlLabel, Checkbox } from "@mui/material";
export default function CreateFeatureForm(props: any) {
  const { formik } = props;
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          sx={{ mt: "2%" }}
          name="featureName"
          label="Feature Name"
          placeholder="Enter Feature Name"
          value={formik.values.featureName}
          onChange={formik.handleChange}
          error={Boolean(formik.errors.featureName)}
          helperText={
            formik.errors.featureName ||
            `${formik.values.featureName.trim().length}/100`
          }
          required
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          minRows={5}
          name="featureDescription"
          label="Description"
          placeholder="Enter Description"
          value={formik.values.featureDescription}
          onChange={formik.handleChange}
          error={Boolean(formik.errors.featureDescription)}
          helperText={
            formik.errors.featureDescription ||
            `${formik.values.featureDescription.trim().length}/500`
          }
        />
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          sx={{ mb: "2%" }}
          control={
            <Checkbox
              name="requireAll"
              color="primary"
              checked={formik.values.requireAll}
              onChange={formik.handleChange}
            />
          }
          label="Require All Attributes To Access Feature?"
        />
      </Grid>
    </Grid>
  );
}
